import React from "react";
import MissionSection from "./MissionSection";
import StatsSection from "./StatsSection";
import TeamSection from "./TeamSection";

const About = () => {
  return (
    <div className="container py-5">
      <MissionSection />

      <div className="font_17 font_500 text-black py-4 py-lg-5 line_height1_7">
        Driven by innovation and precision, PCS empowers industries to unlock
        new levels of efficiency through intelligent automation. Whether it’s
        scanning passports, Aadhaar, or PAN cards, our platform delivers
        reliable and scalable results designed for the digital age.{" "}
      </div>

      <StatsSection />
      <TeamSection />
    </div>
  );
};

export default About;
